module.exports = __webpack_public_path__ + "static/media/x-3.232549b5.svg";